import { z } from "zod";

export const OccupancyReportFilterSchemaV4 = z.object({
    property_id: z.string(), // Memastikan property_id adalah rentetan
    year: z.number().int().min(2000).max(2100), // Tahun untuk occupancy report
});

export type OccupancyReportFilterV4Type = z.infer<typeof OccupancyReportFilterSchemaV4>;